// habitTick.js — THE habit-tick math (2026-10-22), shared by logHabit (a tap on
// the card, today) and the Health-side tick (a workout logged for today or up
// to 2 days back). One completion per local date; the week count counts a date
// in the current Monday-start week, capped at twice the target. Pure.
//
// STREAK (2026-10-24): a tick for TODAY counts the streak up once (the card's
// own tap). A tick for a PAST date — a confirmed workout commitment, Health's
// "+ Log workout" backdated, any backfill — RECOMPUTES it from the full
// completions instead: incrementing a stored counter for a backfilled day
// undercounts (rock's Gym habit read 1 over four consecutive logged days,
// Oct 23) and overcounts across a gap. The definition is the one the app lives
// by: the run of consecutive local dates ending at the latest log. (The load
// path zeroes a run whose latest log is older than yesterday; that stays the
// loader's job, so a recomputed value for a lapsed run is harmless.)
//
// MATCHED PAIR with supabase/migrations/20261024_habit_streak_recompute.sql
// (the one-time fix of stored streaks) — change both or neither.
const dayMs = (d) => { const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(d || '')); return m ? Date.UTC(+m[1], +m[2] - 1, +m[3]) : null; };

/** Length of the run of consecutive dates ending at the latest date in `completions`. 0 when empty. */
export function streakFromCompletions(completions) {
  const days = [...new Set((Array.isArray(completions) ? completions : []).map(d => String(d).slice(0, 10)).filter(d => dayMs(d) != null))].sort();
  if (!days.length) return 0;
  let run = 1;
  for (let i = days.length - 1; i > 0; i--) {
    if (Math.round((dayMs(days[i]) - dayMs(days[i - 1])) / 86400000) === 1) run++;
    else break;
  }
  return run;
}

export function applyHabitTick(h, { date, count = 1, target = 5, weekStart = '0000-00-00', keepSince = '0000-00-00', today = null } = {}) {
  if (!h || !date) return null;
  const completions = Array.isArray(h.completions) ? h.completions : [];
  if (completions.includes(date)) return null; // already logged that day
  const t = Number(target) > 0 ? Number(target) : 5;
  const inWeek = date >= weekStart;
  const weekCount = inWeek ? Math.min((Number(h.weekCount) || 0) + count, t * 2) : (Number(h.weekCount) || 0);
  const trimmed = [...completions, date].filter(d => d >= keepSince).sort();
  const lastLoggedDate = h.lastLoggedDate && h.lastLoggedDate > date ? h.lastLoggedDate : date;
  const prior = Number(h.streak) || 0;
  let streak = prior + 1;
  if (today && date < today) {
    streak = streakFromCompletions(trimmed);
    // History is kept to ~90 days. A run that reaches the oldest kept day may
    // be longer than we can see; never shrink a streak the window cuts off.
    if (streak === trimmed.length && keepSince !== '0000-00-00' && dayMs(trimmed[0]) - dayMs(keepSince) <= 86400000) streak = Math.max(streak, prior + 1);
  }
  return { weekCount, streak, completions: trimmed, lastLoggedDate };
}
